<template lang="html">
  <form class="wcc">
    <h2>Email</h2>
    <div class="wcc input-group">
      <label for="to">To</label>
      <input v-model="email" readonly type="text" name="to" id="to" autocomplete="nope">
      <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="wcc sign-out" v-hammer:tap="signOut" title="Sign Out"/>
    </div>

    <div class="wcc input-group">
      <label for="additionalRecipients">Additional Recipients</label>
      <input v-model="additionalRecipients" @blur="$v.additionalRecipients.$touch()" @focus="commitInput" :class="{invalid: $v.additionalRecipients.$error}" type="email" multiple name="additionalRecipients" id="additionalRecipients" autocomplete="nope">
      <transition name="fade" mode="out-in">
        <p class="wcc error-text" v-if="!$v.additionalRecipients.mutlipleEmails">Please provide a list of email addresses separated by commas or spaces.</p>
        <p class="wcc error-text" v-else-if="!$v.additionalRecipients.maximumTenEmails">You may only send to 10 additional recipients.</p>
      </transition>
    </div>

    <div class="wcc input-group">
      <label for="address" :class="{required: 'required' in $v.address}">Street Address</label>
      <input v-model="address" @blur="$v.address.$touch()" @focus="commitInput" :class="{invalid: $v.address.$error}" type="text" name="address" id="address" autocomplete="nope">
      <transition name="fade" mode="out-in">
        <p class="wcc error-text" v-if="$v.address.$error">Please provide a property address.</p>
      </transition>
    </div>

    <div class="wcc input-group">
      <label for="comments" autocomplete="nope">Comments</label>
      <textarea rows="5" name="comments" id="comments" v-model="comments" @blur="$v.comments.$touch()" @focus="commitInput" :class="{invalid: $v.comments.$error}"></textarea>
      <transition name="fade" mode="out-in">
        <p class="wcc error-text" v-if="$v.comments.$error">This field may not contain links.</p>
      </transition>
    </div>

    <Button :invalid="$v.$anyError" :value="'Send'" :submitting="calculatorData.emailSending" v-hammer:tap="onSubmit"></Button>
  </form>
</template>
<script>
  import Button from '@/components/Button.vue'
  import { required } from 'vuelidate/lib/validators'

  const mutlipleEmails = value => {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true
    }

    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let emails = value.split(/[ ,]+/).map(item => item.trim())
    for(var i = 0;i < emails.length;i++) {
      if(!re.test(emails[i])) {
        return false
      }
    }
    return true
  }

  const maximumTenEmails = (value) => {
    let emails = []
    value.split(/[ ,]+/).map(item => item.trim()).forEach((element) => {
      emails.push(element)
    })
    return emails.length <= 10 ? true : false
  }

  const url = value => {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true
    }
    const re = /[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
    return re.test(value) ? false : true
  }

  export default {
    props: ['calculatorData'],
    data() {
      return {
        address: '',
        additionalRecipients: '',
        comments: ''
      }
    },
    validations: {
      address: {
        required
      },
      additionalRecipients: {
        mutlipleEmails,
        maximumTenEmails
      },
      comments: {
        url
      }
    },
    computed: {
      email() {
        if(this.$store.state.auth.userData) {
          return this.$store.state.auth.userData.email
        }
        return null
      }
    },
    methods: {
      subject() {
        return `Fee Calculation: ${this.address}`
      },
      additionalRecipientsList() {
        let additionalRecipients = []
        if (this.additionalRecipients) {
          this.additionalRecipients.split(/[ ,]+/).map(item => item.trim()).forEach((element) => {
            additionalRecipients.push(element)
          })
        }
        return additionalRecipients
      },
      body() {
        let body = ``
        this.comments.length > 0 ? body += 
`Comments
---
${this.comments}

` : ''
        body +=
`Fees for ${this.address}
---

${this.calculatorData.summaryString()}

Results
---
${this.calculatorData.resultsString()}

Note: The contents of this email are not a replacement for the REBGV Disclosure to Seller of Expected Remuneration.`
        return body
      },
      cleanup() {
        this.address = ''
        this.additionalRecipients = ''
        this.comments = ''
        this.calculatorData.emailSent = false
        this.calculatorData.emailSending = false
        this.calculatorData.emailShow = false
      },
      onSubmit($event) {
        $event.preventDefault()
        if (!this.$v.$anyError && !this.calculatorData.emailSending) {
          this.calculatorData.emailSending = true

          let vm = this
          this.$store.dispatch('auth/extendSession').then(() => {
            vm.axios.post(
              "https://us-central1-mr-fee-calc-mobile.cloudfunctions.net/send", {
                "idToken": vm.$store.state.auth.sessionData.idToken,
                "data": {
                  "subject": vm.subject(),
                  "additionalRecipients": this.additionalRecipientsList(),
                  "body": vm.body()
                }
              },
              {
                headers: {
                  "content-type": 'application/json'
                }
              }
            ).then(() => {
              vm.calculatorData.emailSent = true
              setTimeout(() => {
                vm.cleanup()
              }, 2000)
            }).catch(error => {
              this.calculatorData.emailSending = false
              console.log(error.response)
            })
          })
        }
      },
      signOut() {
        this.$store.dispatch('auth/signOut')
      },
      commitInput() {
        this.$store.dispatch('appInput/commitInput')
      }
    },
    components: {
      Button
    }
  }
</script>
<style lang="scss">
  form.wcc {
    svg.wcc.sign-out {
      right: 0;
      padding: $spacing * .3;
      bottom: $spacing * 0;
      height: 2em;
      width: 2em;
      position: absolute;
      cursor: pointer;
      color: $grey-500;
      transition-duration: $transition-duration;
      @media (hover: hover) {
        &:hover {
          color: $red;
        }
      }
      &:focus {
        color: $red;
      }
    }
  }
</style>